import { useEffect, useState } from 'react';

import { isBrowser } from '../../utils/dialog/collections';

export type SSRState = {
  isBrowser: boolean;
  isServer: boolean;
};
// 서버 실행인지 브라우저 실행인지 판단
const useSSR = (): SSRState => {
  const [browser, setBrowser] = useState<boolean>(false);
  useEffect(() => {
    setBrowser(isBrowser());
  }, []);

  return {
    isBrowser: browser,
    isServer: !browser
  };
};

export default useSSR;
